<template>
    <div style="background-color: #fff;padding:24px;">
        <el-row :gutter="20">
            <el-col :span="8">
                <mileage_time_line :traceData="traceData" ></mileage_time_line>
            </el-col>
            <el-col :span="8">
                <mileage_total_info :drivingdata="drivingdata" ></mileage_total_info>
            </el-col>
            <el-col :span="8">
                <kl_radar_chart :drivingScore="drivingScore"></kl_radar_chart>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mileage_time_line from "./mileage_time_line"
import mileage_total_info from "./mileage_total_info"
import kl_radar_chart from "./kl_radar_chart"
export default {
    components: {
        mileage_time_line,mileage_total_info,kl_radar_chart
    },
	props: {
		 traceData: {
		    type: Array,
		    default: () => [] // 默认值为空数组，确保可迭代
		  }, 
		 drivingScore:Array,
		  drivingdata: {
		       type: Object,
		       default: () => ({
		         Consume: 0.0,
		         Duration: 0.0,
		         Speed: 0.0,
		         Mileage: 0.0
		       })
		     }
		 
	},
	data() {
		return {
			traceDataTemp: this.traceData,
			localDrivingdata: { ...this.drivingdata },
			localDrivingScore: [...this.drivingScore],
		}
	},
	  watch: {
	    // 2. 监听 prop 变化，同步到本地数据
	    drivingdata(newVal) {
	      this.localDrivingdata = { ...newVal }; // 深拷贝避免引用关联
	    }
	  },
}
</script>